import styled from "styled-components";

export default styled.span`
  font-size: 20px;
  line-height: 1.25;
  font-weight: 500;
`;
